import React from 'react'

const LogoBackground02 = () => {
    return (
        <div className="logo-background-02">
            <img src="../content/Labo-Lol_logo_noir_02.png" alt="logo" />
        </div>
    )
}

export default LogoBackground02